// Version : 0.0.1
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// MODFIED DATE:31-07-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START ADD INSURANCE COMPANY DETAILS  ******************** */
export const insuranceCompanyDetailsAdd = (addData: any) => {
	const data = {
		AddInsuranceCompanyDetailsToken: addData,
	};
	const url = `${API_URL}addInsuranceCompanyDetails`;
	return makeApiCall(url, data);
};
/** *********************  END ADD INSURANCE COMPANY DETAILS  ******************** */

/*************** START UPDATE INSURANCE COMPANY DETAILS ******************/
export const insuranceCompanyDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateInsuranceCompanyDetailsToken: updateData,
	};
	const url = `${API_URL}updateInsuranceCompanyDetails`;
	return makeApiCall(url, data);
};
/*************** END UPDATE INSURANCE COMPANY DETAILS ******************/

/*************** START GET INSURANCE COMPANY LIST ******************/
export const insuranceCompanyListGet = (listData: any) => {
	const data = {
		GetInsuranceCompanyListToken: listData,
	};
	const url = `${API_URL}getInsuranceCompanyList`;
	return makeApiCall(url, data);
};
/*************** END GET INSURANCE COMPANY LIST ******************/

/*************** START FETCH INSURANCE COMPANY DETAILS ******************/
export const insuranceCompanyDetailsFetch = (fetchData: any) => {
	const data = {
		FetchInsuranceCompanyDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchInsuranceCompanyDetails`;
	return makeApiCall(url, data);
};
/*************** END FETCH INSURANCE COMPANY DETAILS ******************/

/*************** START DELETE INSURANCE COMPANY DETAILS ******************/
export const insuranceCompanyDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteInsuranceCompanyDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteInsuranceCompanyDetails`;
	return makeApiCall(url, data);
};
/*************** END DELETE INSURANCE COMPANY DETAILS ******************/

/*************** START FETCH ALL INSURANCE COMPANYS ******************/
export const allInsuranceCompanyFetch = (fetchData: any) => {
	const data = {
		AllInsuranceCompanyListFetchToken: fetchData,
	};
	const url = `${API_URL}fetchAllInsuranceCompanyList`;
	return makeApiCall(url, data);
};
/*************** END FETCH ALL INSURANCE COMPANYS ******************/
